const Vue = require('vue')
const R = require('ramda')

Vue.component('form-rate', {
    props: {
        label: {
            type: String
        },
        placeholder: {
            type: String
        },
        iconClass: {
            type: String
        },
        max: {
            default: 5,
            type: Number
        },
        model: {
            twoWay: true,
            default: null,
            required: true
        },
        onChange: {
            default: null,
            type: Function
        }
    },
    methods: {
        holderClass () {
            return this.iconClass ? 'input-icon' : null
        },
        hoverStar (star) {
            this.hoveredStar = star
        },
        starClass (star) {
            if (this.hoveredStar > 0 && star <= this.hoveredStar) {
                return 'fa-star'
            }

            if (this.hoveredStar < 1 && star <= this.model) {
                return 'fa-star'
            }

            return 'fa-star-o'
        },
        pickStar (star) {
            this.model = star
            this.hoveredStar = 0

            if (this.onChange) {
                this.onChange(star)
            }
        }
    },
    data () {
        return {
            fieldName: '',
            stars: [],
            hoveredStar: 0
        }
    },
    ready () {
        this.fieldName = this._props.model.raw

        if (!this.placeholder) {
            this.placeholder = this.label
        }

        this.stars = R.range(1, this.max + 1)
    },
    template: `
            <div class="stars-container">
                <label v-if="label">{{ label }}</label>
                <div class="" @mouseleave="hoverStar(model)">
                    <i v-for="star in stars" @mouseenter="hoverStar(star)" @click="pickStar(star)" class="fa" v-bind:class="starClass(star)"></i>
                </div>
                <div class="font-medium-grey" @click="pickStar(0)">&nbsp<i class="fa fa-times" v-tooltip title="Limpar"></i> Limpar</div>
                <div class="clearfix"></div>
            </div>
        `
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/rate.js